import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
// Importe diretamente do arquivo criado
import Login from './pages/Login';
import { createTheme, ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import Dashboard from './pages/Dashboard';
import EmitirSenha from './pages/EmitirSenha';
import Usuarios from './pages/Usuarios';
import Configuracoes from './pages/ConfigIndex';
import PainelChamada from './pages/PainelChamada';
import PainelConfiguracao from './pages/PainelConfiguracao';
import Aparencia from './pages/Aparencia';
import ServicoSenhas from './pages/ServicoSenhas';
import PainelRecepcao from './pages/PainelRecepcao';
import ConfiguracaoTickets from './pages/ConfiguracaoTickets';
import Relatorios from './pages/Relatorios';
import Home from './pages/Home';
import UnauthorizedPage from './components/UnauthorizedPage';
import RoleRoute from './components/RoleRoute';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import Branding from './pages/Branding';
// Importar a fonte Montserrat do Google Fonts
import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/700.css';
// Importar utilitários
import './utils/pdfUtils';
// Importar página de debug de PDF
import PdfDebug from './pages/PdfDebug';

const PrivateRoute = ({ children }) => {
  const { signed, loading } = useAuth();
  console.log('PrivateRoute - Estado de autenticação:', { signed, loading });

  if (loading) {
    return <div>Carregando...</div>;
  }

  return signed ? children : <Navigate to="/login" />;
};

const AppContent = () => {
  const { isDarkMode } = useTheme();

  // Criando um tema personalizado
  const theme = createTheme({
    typography: {
      fontFamily: [
        'Montserrat',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      button: {
        textTransform: 'none',
        fontWeight: 500,
      },
      h1: {
        fontWeight: 700,
      },
      h2: {
        fontWeight: 700,
      },
      h3: {
        fontWeight: 600,
      },
      h4: {
        fontWeight: 600,
      },
      h5: {
        fontWeight: 600,
      },
      h6: {
        fontWeight: 600,
      },
    },
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
      background: {
        default: isDarkMode ? '#121212' : '#f5f5f5',
        paper: isDarkMode ? '#1e1e1e' : '#ffffff',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            transition: 'background-color 0.3s ease',
            fontFamily: 'Montserrat, sans-serif',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 500,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: 'Montserrat, sans-serif',
          },
        },
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          
          {/* Rotas protegidas com controle de acesso por cargo */}
          <Route
            path="/home"
            element={
              <RoleRoute path="/home">
                <Home />
              </RoleRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RoleRoute path="/dashboard">
                <Dashboard />
              </RoleRoute>
            }
          />
          <Route
            path="/emitir-senha"
            element={
              <RoleRoute path="/emitir-senha">
                <EmitirSenha />
              </RoleRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <RoleRoute path="/usuarios">
                <Usuarios />
              </RoleRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <RoleRoute path="/configuracoes">
                <Configuracoes />
              </RoleRoute>
            }
          />
          <Route 
            path="/configuracoes/servicos-senhas" 
            element={
              <RoleRoute path="/configuracoes/servicos-senhas">
                <ServicoSenhas />
              </RoleRoute>
            } 
          />
          <Route 
            path="/painel-configuracao" 
            element={
              <RoleRoute path="/painel-configuracao">
                <PainelConfiguracao />
              </RoleRoute>
            } 
          />
          <Route 
            path="/branding" 
            element={
              <RoleRoute path="/branding">
                <Branding />
              </RoleRoute>
            }
          />
          <Route 
            path="/aparencia" 
            element={
              <RoleRoute path="/aparencia">
                <Aparencia />
              </RoleRoute>
            } 
          />
          <Route 
            path="/configuracao-tickets" 
            element={
              <RoleRoute path="/configuracao-tickets">
                <ConfiguracaoTickets />
              </RoleRoute>
            } 
          />
          <Route 
            path="/painel-chamada" 
            element={
              <RoleRoute path="/painel-chamada">
                <PainelChamada />
              </RoleRoute>
            } 
          />
          <Route
            path="/painel-recepcao"
            element={
              <RoleRoute path="/painel-recepcao">
                <PainelRecepcao />
              </RoleRoute>
            }
          />
          <Route
            path="/relatorios"
            element={
              <RoleRoute path="/relatorios">
                <Relatorios />
              </RoleRoute>
            }
          />
          <Route
            path="/pdf-debug"
            element={
              <RoleRoute path="/pdf-debug">
                <PdfDebug />
              </RoleRoute>
            }
          />
          {/* Redirecionar a rota raiz para a página home */}
          <Route path="/" element={<Navigate to="/home" />} />
          
          {/* Redirecionamentos para compatibilidade */}
          <Route path="/configuracao-impressao" element={<Navigate to="/configuracao-tickets" />} />
          <Route path="/editor-template" element={<Navigate to="/configuracao-tickets" />} />
        </Routes>
      </Router>
    </MuiThemeProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrandingProvider>
          <AppContent />
        </BrandingProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
